var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgIconGoogleplay = function SvgIconGoogleplay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 203,
    height: 61,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon-googleplay_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M195.14 59.965H7.726c-4.123 0-7.497-3.358-7.497-7.463V7.726C.23 3.622 3.603.263 7.726.263H195.14c4.123 0 7.497 3.359 7.497 7.463v44.776c0 4.105-3.374 7.463-7.497 7.463Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.14.263H7.726C3.603.263.23 3.622.23 7.726v44.776c0 4.105 3.374 7.463 7.497 7.463H195.14c4.123 0 7.497-3.358 7.497-7.463V7.726c0-4.104-3.374-7.463-7.497-7.463Zm0 1.194c3.473 0 6.297 2.813 6.297 6.269v44.776c0 3.457-2.824 6.27-6.297 6.27H7.726c-3.472 0-6.297-2.813-6.297-6.27V7.726c0-3.456 2.825-6.269 6.297-6.269H195.14Z",
    fill: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.325 15.552c0 1.25-.372 2.246-1.117 2.989-.847.883-1.95 1.325-3.305 1.325-1.299 0-2.403-.447-3.31-1.344-.91-.896-1.364-2.008-1.364-3.333 0-1.327.454-2.437 1.363-3.334.908-.896 2.012-1.345 3.31-1.345.645 0 1.262.126 1.847.376.586.25 1.056.584 1.407 1l-.79.788c-.596-.708-1.416-1.062-2.463-1.062-.947 0-1.766.33-2.457.994-.691.663-1.037 1.524-1.037 2.583 0 1.058.346 1.919 1.037 2.582.69.663 1.51.994 2.457.994 1.004 0 1.842-.332 2.512-1 .435-.434.687-1.038.754-1.813h-3.266v-1.076h4.359c.042.234.063.458.063.676",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.325 15.552h-.15c-.001 1.222-.36 2.171-1.073 2.884H70.1v.002c-.82.853-1.873 1.277-3.197 1.28-1.264-.003-2.322-.432-3.205-1.302-.881-.871-1.317-1.935-1.319-3.227.002-1.293.438-2.356 1.319-3.227.883-.87 1.94-1.3 3.205-1.302.625 0 1.22.121 1.787.363.568.244 1.017.563 1.351.96l.115-.097-.106-.105-.79.788.105.105.116-.095c-.623-.744-1.498-1.119-2.578-1.116a3.579 3.579 0 0 0-2.56 1.036c-.722.69-1.085 1.599-1.084 2.69 0 1.09.362 2 1.083 2.69a3.58 3.58 0 0 0 2.56 1.036c1.038.002 1.923-.349 2.62-1.044.464-.464.728-1.107.797-1.906l.014-.162h-3.28v-.778h4.209v-.149l-.148.027c.041.226.06.44.06.649h.3c0-.227-.02-.46-.065-.702l-.022-.123h-4.634v1.375h3.416v-.15l-.149-.013c-.066.751-.306 1.317-.71 1.721-.645.64-1.436.955-2.407.956-.912 0-1.686-.313-2.353-.952-.66-.636-.99-1.448-.99-2.475 0-1.028.33-1.84.99-2.476.667-.638 1.44-.95 2.353-.952 1.013.003 1.779.336 2.348 1.01l.105.124.906-.903.097-.097-.088-.104c-.368-.437-.86-.784-1.463-1.042a4.806 4.806 0 0 0-1.905-.388c-1.333 0-2.484.465-3.417 1.388-.936.922-1.408 2.08-1.407 3.44-.001 1.36.471 2.518 1.408 3.44.932.922 2.083 1.388 3.416 1.387 1.388 0 2.54-.458 3.413-1.372l-.108-.103.106.106c.776-.773 1.162-1.816 1.16-3.095h-.15ZM78.235 11.811H74.14v2.84h3.694v1.076h-3.694v2.84h4.096v1.1h-5.251V10.71h5.251v1.1Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.235 11.811v-.149H73.99V14.8h3.694v.777H73.99v3.138h4.096v.802h-4.951v-8.656h4.951v.95h.15v-.149.15h.15v-1.25h-5.551v9.254h5.551v-1.399h-4.097v-2.54h3.695V14.5h-3.695v-2.54h4.097v-.15h-.15M83.11 19.666h-1.157v-7.855h-2.512v-1.1h6.181v1.1H83.11v7.855Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.11 19.666v-.149h-1.007v-7.855h-2.512v-.802h5.882v.802H82.96v8.004h.15v-.149.15h.15V11.96h2.512v-1.4h-6.481v1.4h2.512v7.855H83.26v-.15h-.15M90.095 19.666v-8.955h1.156v8.955h-1.156Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.095 19.666h.15V10.86h.856v8.657h-1.006v.15h.15-.15v.149H91.401v-9.254h-1.456v9.254h.15v-.15ZM96.378 19.666h-1.156v-7.855h-2.513v-1.1h6.182v1.1h-2.513v7.855Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.378 19.666v-.149h-1.007v-7.855H92.86v-.802h5.882v.802h-2.513v8.004h.15v-.149.15h.15V11.96h2.513v-1.4h-6.482v1.4h2.513v7.855h1.456v-.15h-.15M104.851 17.76c.665.67 1.48 1.005 2.444 1.005.963 0 1.778-.335 2.443-1.006.666-.67 1-1.529 1-2.57 0-1.042-.334-1.9-1-2.571-.665-.671-1.48-1.006-2.443-1.006-.964 0-1.779.335-2.444 1.006s-.999 1.529-.999 2.57c0 1.042.334 1.9.999 2.571Zm5.742.749c-.884.905-1.984 1.357-3.298 1.357-1.316 0-2.415-.452-3.298-1.357-.885-.904-1.325-2.011-1.325-3.32 0-1.31.44-2.416 1.325-3.32.883-.906 1.982-1.359 3.298-1.359 1.307 0 2.404.455 3.292 1.364.887.91 1.331 2.014 1.331 3.315 0 1.309-.442 2.416-1.325 3.32Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m104.851 17.76-.107.104c.691.698 1.552 1.053 2.551 1.05.998.003 1.86-.352 2.55-1.05.695-.698 1.044-1.602 1.043-2.675.001-1.073-.348-1.977-1.043-2.676-.69-.698-1.552-1.052-2.55-1.05-.999-.002-1.86.352-2.551 1.05-.693.699-1.044 1.603-1.042 2.676-.002 1.073.349 1.977 1.042 2.675l.107-.105.106-.105c-.636-.644-.954-1.454-.955-2.465.001-1.011.319-1.822.955-2.466.642-.644 1.409-.96 2.338-.962.928.002 1.696.318 2.336.962.638.644.956 1.455.957 2.466-.001 1.01-.319 1.821-.957 2.465-.64.645-1.408.96-2.336.962-.929-.001-1.696-.317-2.338-.962l-.106.105Zm5.742.75-.107-.105c-.86.877-1.911 1.31-3.191 1.312-1.281-.002-2.333-.435-3.191-1.312l-.004-.004.004.004c-.858-.88-1.281-1.94-1.282-3.216.001-1.276.424-2.337 1.282-3.217.858-.877 1.91-1.31 3.191-1.312 1.272.002 2.321.437 3.185 1.319.861.884 1.287 1.943 1.289 3.21-.002 1.275-.427 2.337-1.283 3.216l.107.104.108.104c.909-.93 1.368-2.082 1.367-3.424.001-1.335-.46-2.485-1.373-3.418-.914-.938-2.058-1.411-3.4-1.41-1.35-.001-2.498.47-3.406 1.404-.91.929-1.368 2.082-1.367 3.424-.001 1.342.457 2.494 1.367 3.424l.005.005-.005-.005c.908.933 2.056 1.404 3.406 1.403 1.348 0 2.496-.47 3.406-1.403l-.108-.104M113.541 19.666v-8.955h1.407l4.372 6.967h.049l-.049-1.726V10.71h1.156v8.955h-1.206l-4.574-7.304h-.05l.05 1.726v5.578h-1.155Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.541 19.666h.15V10.86h1.173l4.372 6.967H119.523l-.054-1.877v-5.09h.857v8.657h-.973l-4.574-7.304H114.492l.054 1.878v5.426h-1.005v.15h.15-.15v.149h1.305v-5.73l-.05-1.728-.15.004v.15h.05v-.15l-.128.08 4.618 7.374h1.44v-9.254h-1.456v5.392l.049 1.728.15-.004v-.15h-.05v.15l.128-.08-4.416-7.036h-1.64v9.254h.15v-.15ZM160.56 45.04h2.798V26.38h-2.798v18.66Zm25.199-11.938-3.207 8.09h-.096l-3.328-8.09h-3.014l4.991 11.306-2.845 6.29h2.919l7.691-17.596h-3.111Zm-15.866 9.818c-.917 0-2.195-.456-2.195-1.584 0-1.44 1.593-1.993 2.966-1.993 1.231 0 1.808.264 2.556.625a3.386 3.386 0 0 1-3.327 2.952Zm.338-10.226c-2.026 0-4.123.888-4.992 2.857l2.483 1.032c.531-1.032 1.519-1.369 2.557-1.369 1.447 0 2.917.865 2.941 2.401v.192c-.506-.288-1.59-.72-2.917-.72-2.677 0-5.402 1.464-5.402 4.2 0 2.497 2.195 4.106 4.654 4.106 1.881 0 2.917-.84 3.569-1.825h.096v1.44h2.701v-7.153c0-3.312-2.483-5.161-5.69-5.161Zm-17.29 2.68h-3.98v-6.396h3.98c2.091 0 3.279 1.724 3.279 3.197 0 1.447-1.188 3.198-3.279 3.198Zm-.072-8.993h-6.704v18.658h2.796V37.97h3.908c3.1 0 6.148-2.234 6.148-5.794 0-3.56-3.048-5.795-6.148-5.795Zm-36.555 16.543c-1.933 0-3.551-1.611-3.551-3.824 0-2.236 1.618-3.871 3.551-3.871 1.908 0 3.406 1.635 3.406 3.871 0 2.213-1.498 3.824-3.406 3.824Zm3.212-8.777h-.096c-.628-.745-1.836-1.419-3.358-1.419-3.188 0-6.111 2.79-6.111 6.372 0 3.559 2.923 6.324 6.111 6.324 1.522 0 2.73-.673 3.358-1.442h.096v.913c0 2.43-1.304 3.728-3.405 3.728-1.715 0-2.778-1.227-3.213-2.26l-2.44 1.01c.701 1.682 2.561 3.75 5.653 3.75 3.285 0 6.062-1.924 6.062-6.612V33.113h-2.657v1.034Zm4.59 10.892h2.801V26.38h-2.801v18.66Zm6.932-6.155c-.072-2.453 1.908-3.703 3.333-3.703 1.112 0 2.054.553 2.367 1.347l-5.7 2.356Zm8.696-2.116c-.531-1.419-2.15-4.04-5.459-4.04-3.285 0-6.015 2.573-6.015 6.348 0 3.56 2.706 6.348 6.328 6.348 2.924 0 4.615-1.78 5.315-2.813l-2.174-1.443c-.724 1.058-1.715 1.756-3.141 1.756-1.424 0-2.439-.65-3.091-1.924l8.526-3.51-.289-.722Zm-67.932-2.092v2.693h6.474c-.194 1.515-.7 2.62-1.474 3.39-.941.938-2.415 1.972-5 1.972-3.985 0-7.1-3.198-7.1-7.165 0-3.968 3.115-7.166 7.1-7.166 2.15 0 3.72.842 4.88 1.924l1.908-1.9c-1.618-1.539-3.768-2.717-6.788-2.717-5.459 0-10.048 4.424-10.048 9.859 0 5.434 4.59 9.858 10.048 9.858 2.948 0 5.17-.961 6.908-2.765 1.788-1.78 2.344-4.28 2.344-6.3 0-.625-.048-1.202-.146-1.683h-9.106Zm16.611 8.248c-1.933 0-3.6-1.587-3.6-3.848 0-2.284 1.667-3.847 3.6-3.847 1.932 0 3.599 1.563 3.599 3.847 0 2.26-1.667 3.848-3.599 3.848Zm0-10.196c-3.527 0-6.401 2.67-6.401 6.348 0 3.655 2.874 6.348 6.401 6.348 3.526 0 6.4-2.693 6.4-6.348 0-3.679-2.874-6.348-6.4-6.348Zm13.964 10.196c-1.932 0-3.6-1.587-3.6-3.848 0-2.284 1.668-3.847 3.6-3.847 1.932 0 3.599 1.563 3.599 3.847 0 2.26-1.667 3.848-3.599 3.848Zm0-10.196c-3.527 0-6.401 2.67-6.401 6.348 0 3.655 2.874 6.348 6.401 6.348 3.526 0 6.4-2.693 6.4-6.348 0-3.679-2.874-6.348-6.4-6.348Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.987 48.606-.111-.106c-.437-.46-.694-1.173-.694-2.098v.218V13.603v.227c0-1.001.3-1.755.803-2.207l18.576 18.492-18.574 18.49ZM15.182 13.6Zm.006-.244v-.003.003Zm0-.01v-.002.002Z",
    fill: "url(#icon-googleplay_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m40.752 36.5.142-.08 7.336-4.15c.7-.395 1.165-.875 1.398-1.383-.232.508-.698.988-1.398 1.384l-7.336 4.15-.142.079Zm.002-.219-6.193-6.166 6.193-6.165 7.476 4.228c.95.537 1.482 1.23 1.571 1.936v.003c-.089.706-.622 1.399-1.571 1.935l-7.476 4.23",
    fill: "url(#icon-googleplay_svg__c)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.311 49.31c-.519 0-.971-.168-1.325-.485h.001c.353.316.806.485 1.325.485Zm0-.219c-.518.001-.97-.168-1.324-.485l18.574-18.49 6.193 6.165-21.763 12.31c-.602.34-1.172.5-1.68.5Zm-1.33-.27a2.027 2.027 0 0 1-.096-.094l.097.094Z",
    fill: "url(#icon-googleplay_svg__d)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.561 30.115 15.985 11.623c.353-.316.806-.484 1.324-.484.508 0 1.08.162 1.682.502l21.763 12.31-6.193 6.164Zm6.333-6.304L18.992 11.423c-.604-.34-1.175-.502-1.683-.502h-.007.01c.506 0 1.077.16 1.68.501l21.902 12.39Z",
    fill: "url(#icon-googleplay_svg__e)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.45 49.307c.47-.027.993-.189 1.541-.498l21.761-12.31-21.76 12.31c-.549.31-1.071.47-1.543.498Zm-1.464-.482-.004-.004a.047.047 0 0 1 .004.004Zm-.1-.098-.01-.01.01.01Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m40.752 36.5.142-.08-.142.08Z",
    fill: "url(#icon-googleplay_svg__f)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.312 49.31c-.518 0-.972-.169-1.325-.486v.001a.037.037 0 0 0-.005-.004l-.097-.094-.01-.01.112-.11c.353.316.806.485 1.325.484.507 0 1.077-.16 1.68-.5l21.762-12.31.14.14-.142.079-21.76 12.309c-.55.31-1.071.47-1.543.498a2.763 2.763 0 0 1-.137.003",
    fill: "url(#icon-googleplay_svg__g)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.876 48.718c-.437-.46-.694-1.173-.694-2.097v-.001c0 .925.257 1.638.694 2.097",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.876 48.717c-.437-.46-.694-1.172-.694-2.097v-.217c0 .924.257 1.637.694 2.097l.11.106-.11.111",
    fill: "url(#icon-googleplay_svg__h)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.876 48.717.111-.111-.111.111",
    fill: "url(#icon-googleplay_svg__i)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.628 30.887a1.845 1.845 0 0 1 0 0Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m40.894 36.42-.14-.139 7.476-4.228c.95-.537 1.482-1.23 1.571-1.936 0 .26-.058.518-.173.77-.233.508-.699.988-1.398 1.383l-7.336 4.15Z",
    fill: "url(#icon-googleplay_svg__j)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.801 30.115c0-.781-.525-1.562-1.571-2.154l-7.336-4.15 7.336 4.15c1.048.592 1.572 1.373 1.571 2.154Z",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.801 30.114c-.089-.707-.622-1.399-1.571-1.936l-7.476-4.228.14-.139 7.336 4.15c1.046.592 1.57 1.373 1.571 2.154Z",
    fill: "url(#icon-googleplay_svg__k)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.182 13.604v-.002.002Zm.006-.243v-.004.004Zm0-.007v-.007.007Zm0-.009c.087-1.533.925-2.419 2.11-2.424-.514.003-.961.17-1.312.485l-.004.004a2.016 2.016 0 0 0-.106.104c-.394.414-.642 1.035-.688 1.831Z",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.182 13.83V13.6c0-.082.002-.162.006-.24v-.016c.046-.796.294-1.417.688-1.831l.11.11c-.504.451-.804 1.205-.804 2.206Zm.8-2.42.004-.005c0 .002-.003.003-.004.004Z",
    fill: "url(#icon-googleplay_svg__l)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.754 23.95 18.992 11.64c-.604-.34-1.175-.501-1.683-.501-.518 0-.97.168-1.324.484l-.11-.11c.035-.035.07-.07.107-.104l.004-.003c.35-.314.798-.482 1.312-.485h.011c.508 0 1.08.161 1.682.502L40.894 23.81l-.14.14Z",
    fill: "url(#icon-googleplay_svg__m)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-googleplay_svg__b",
    x1: 32.914,
    y1: 13.263,
    x2: 7.866,
    y2: 38.425,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.007,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-googleplay_svg__c",
    x1: 50.958,
    y1: 30.116,
    x2: 14.679,
    y2: 30.116,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.775,
    stopColor: "orange"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-googleplay_svg__d",
    x1: 37.453,
    y1: 33.541,
    x2: 3.486,
    y2: 67.663,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-googleplay_svg__e",
    x1: 11.171,
    y1: 0.526,
    x2: 26.338,
    y2: 15.763,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.069,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-googleplay_svg__f",
    x1: 50.958,
    y1: 30.116,
    x2: 14.679,
    y2: 30.116,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCB300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    stopColor: "#CC9700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.775,
    stopColor: "#CC8400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC7D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-googleplay_svg__g",
    x1: 37.453,
    y1: 33.541,
    x2: 3.486,
    y2: 67.663,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC2E36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C0E4E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-googleplay_svg__h",
    x1: 32.914,
    y1: 13.263,
    x2: 7.866,
    y2: 38.425,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008DE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.007,
    stopColor: "#008DE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#00A7E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512,
    stopColor: "#00B8E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00C4E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C7E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-googleplay_svg__i",
    x1: 37.454,
    y1: 33.541,
    x2: 3.486,
    y2: 67.664,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0333C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB0F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-googleplay_svg__j",
    x1: 50.958,
    y1: 30.116,
    x2: 14.679,
    y2: 30.116,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0C500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    stopColor: "#E0A600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.775,
    stopColor: "#E09100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E08900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-googleplay_svg__k",
    x1: 50.958,
    y1: 30.116,
    x2: 14.679,
    y2: 30.116,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE840"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    stopColor: "#FFCE40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.775,
    stopColor: "#FFBC40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB540"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-googleplay_svg__l",
    x1: 32.914,
    y1: 13.263,
    x2: 7.866,
    y2: 38.425,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#40B8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.007,
    stopColor: "#40B9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#40CEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512,
    stopColor: "#40DDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#40E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40EAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-googleplay_svg__m",
    x1: 11.171,
    y1: 0.526,
    x2: 26.338,
    y2: 15.763,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#65B895"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.069,
    stopColor: "#62BD95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476,
    stopColor: "#50DB97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801,
    stopColor: "#44ED98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F498"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "icon-googleplay_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.08 .114)",
    d: "M0 0h202.857v60H0z"
  })))));
};

export default SvgIconGoogleplay;